<ng-container *ngIf="link.children; else listItem">
    <mat-expansion-panel [class.mat-elevation-z0]="true" dense
        [ngClass]="{ 'mobile-hidden': link.isMobileHidden }">
        <mat-expansion-panel-header>
            <mat-panel-title
                [routerLink]="link.route"
                [ngClass]="{ disabled: link.isDisabled || isRouteLoading }"
                routerLinkActive="active">
                <mat-icon aria-label="Nav">{{link.icon}}</mat-icon>
                <span class="link-label">{{link.title | translate}}</span>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list>
            <app-nav-list *ngFor="let child of link.children" [link]="child" [isLittleMode]="isLittleMode">
            </app-nav-list>
        </mat-nav-list>
    </mat-expansion-panel>
</ng-container>

<ng-template #listItem>
    <a mat-list-item *ngIf="link.route"
        [routerLink]="link.route" [attr.disabled]="link.isDisabled || isRouteLoading"
        [ngClass]="{ disabled: link.isDisabled || isRouteLoading, little: isLittleMode, 'mobile-hidden': link.isMobileHidden}"
        routerLinkActive="active">
        <mat-icon aria-label="Nav">{{link.icon}}</mat-icon>
        <span class="link-label">{{link.title | translate}}</span>
    </a>

    <a mat-list-item *ngIf="!link.route"
        [attr.href]="link.url" target="_blank" [attr.disabled]="link.isDisabled"
        [ngClass]="{ disabled: link.isDisabled, little: isLittleMode, 'mobile-hidden': link.isMobileHidden}">
        <mat-icon aria-label="Nav">{{link.icon}}</mat-icon>
        <span class="link-label">{{link.title | translate}}</span>
    </a>
</ng-template>
